// @ts-expect-error This file actually *does* depend on `React` being in scope,
// because the result of `css.resolve` gets inlined when this file is built for
// *publishing* (different to the EQ1 build!), and it uses React.createElement.
//
// Without this import, trying to render `Button` from `@equiem/react-admin-ui`
// outside of the EQ1 monorepo will throw an exception.
//
// eslint-disable-next-line @typescript-eslint/no-unused-vars
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderAdminButtonStyles", {
    enumerable: true,
    get: function() {
        return renderAdminButtonStyles;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const renderAdminButtonStyles = (param)=>{
    let { element, variant, size, inverted, shape, theme } = param;
    const { animationDuration, focusOutline, mutedOpacity, spacers } = theme;
    const disabled = element === "button" ? ":disabled" : ".disabled";
    const paddingVariants = variant === "outline" || variant === "toggle" ? {
        sm: "3px 7px",
        md: "7px 11px",
        lg: "7px 15px"
    } : {
        sm: "4px 8px",
        md: "8px 12px",
        lg: "8px 16px"
    };
    const btnBorders = {
        border: {
            primary: "none",
            secondary: "none",
            outline: "1px solid ".concat(inverted ? theme.colors.transparent.white[50] : theme.colors.transparent.black[10]),
            toggle: "1px solid ".concat(inverted ? theme.colors.transparent.black[5] : theme.colors.transparent.black[10]),
            ghost: "none",
            danger: theme.colors.danger,
            transparent: inverted ? theme.colors.transparent.white[60] : theme.colors.transparent.black[60]
        }[variant],
        hover: {
            border: {
                primary: "none",
                secondary: "none",
                outline: "1px solid ".concat(inverted ? theme.colors.white : theme.colors.primary),
                toggle: "1px solid ".concat(theme.colors.transparent.black[5]),
                ghost: "none",
                danger: "none",
                transparent: "none"
            }[variant]
        }
    };
    const btnBackgrounds = {
        background: {
            primary: inverted ? theme.colors.white : theme.colors.primary,
            secondary: inverted ? theme.colors.transparent.white[15] : theme.colors.secondary,
            outline: "none",
            toggle: "none",
            ghost: "none",
            danger: theme.colors.danger,
            transparent: inverted ? theme.colors.transparent.white[60] : theme.colors.transparent.black[60]
        }[variant],
        hover: {
            background: {
                primary: inverted ? theme.colors.transparent.white[80] : theme.colors.blue[80],
                secondary: inverted ? theme.colors.white : theme.colors.blue.transparent[20],
                outline: "none",
                toggle: theme.colors.grayscale_5,
                ghost: inverted ? theme.colors.transparent.white[15] : theme.colors.transparent.black[5],
                danger: theme.colors.status.danger.dark,
                transparent: inverted ? theme.colors.transparent.white[80] : theme.colors.transparent.black[80]
            }[variant]
        }
    };
    const btnColors = {
        color: {
            primary: inverted ? theme.colors.primary : theme.colors.white,
            secondary: inverted ? theme.colors.white : theme.colors.primary,
            outline: inverted ? theme.colors.white : theme.colors.primary,
            toggle: inverted ? theme.colors.white : theme.colors.black,
            ghost: inverted ? theme.colors.white : theme.colors.medium,
            danger: theme.colors.white,
            transparent: inverted ? theme.colors.black : theme.colors.white
        }[variant],
        hover: {
            color: {
                primary: inverted ? theme.colors.primary : theme.colors.white,
                secondary: theme.colors.primary,
                outline: inverted ? theme.colors.white : theme.colors.primary,
                toggle: inverted ? theme.colors.white : theme.colors.black,
                ghost: inverted ? theme.colors.white : theme.colors.medium,
                danger: theme.colors.white,
                transparent: inverted ? theme.colors.black : theme.colors.white
            }[variant]
        }
    };
    const round = shape === "round";
    const btnRadius = {
        default: "4px",
        round: "50%",
        capsule: {
            sm: "24px",
            md: "32px",
            lg: "40px"
        }[size]
    };
    return {
        styles: /*#__PURE__*/ _react.default.createElement(_style.default, {
            id: "7bd8f376514b45ba",
            dynamic: [
                element,
                variant === "toggle" ? 500 : 700,
                spacers.s2,
                btnRadius[shape],
                round ? "auto" : "nowrap",
                !round ? "auto" : ({
                    sm: "24px",
                    md: "32px",
                    lg: "40px"
                })[size],
                !round ? "auto" : ({
                    sm: "24px",
                    md: "32px",
                    lg: "40px"
                })[size],
                btnBackgrounds.background,
                btnBorders.border,
                btnColors.color,
                round ? "12px" : ({
                    sm: "12px",
                    md: "12px",
                    lg: "14px"
                })[size],
                round ? "12px" : ({
                    sm: "16px",
                    md: "16px",
                    lg: "24px"
                })[size],
                round ? "0" : paddingVariants[size],
                animationDuration,
                element,
                element,
                element,
                btnBackgrounds.hover.background,
                btnBorders.hover.border,
                btnColors.hover.color,
                element,
                focusOutline.size,
                focusOutline.colors.default,
                element,
                disabled,
                element,
                disabled,
                element,
                disabled,
                element,
                disabled,
                element,
                disabled,
                mutedOpacity,
                btnColors.color,
                btnBackgrounds.background,
                btnBorders.border
            ]
        }, "".concat(element, ".__jsx-style-dynamic-selector{cursor:pointer;font-weight:").concat(variant === "toggle" ? 500 : 700, ";text-transform:uppercase;display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;gap:").concat(spacers.s2, ";-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-border-radius:").concat(btnRadius[shape], ";-moz-border-radius:").concat(btnRadius[shape], ";border-radius:").concat(btnRadius[shape], ";white-space:").concat(round ? "auto" : "nowrap", ";overflow:hidden;width:").concat(!round ? "auto" : ({
            sm: "24px",
            md: "32px",
            lg: "40px"
        })[size], ";height:").concat(!round ? "auto" : ({
            sm: "24px",
            md: "32px",
            lg: "40px"
        })[size], ";background:").concat(btnBackgrounds.background, ";border:").concat(btnBorders.border, ";color:").concat(btnColors.color, ";font-size:").concat(round ? "12px" : ({
            sm: "12px",
            md: "12px",
            lg: "14px"
        })[size], ";line-height:").concat(round ? "12px" : ({
            sm: "16px",
            md: "16px",
            lg: "24px"
        })[size], ";padding:").concat(round ? "0" : paddingVariants[size], ";outline:none;-webkit-transition:box-shadow ").concat(animationDuration, ";-moz-transition:box-shadow ").concat(animationDuration, ";-o-transition:box-shadow ").concat(animationDuration, ";transition:box-shadow ").concat(animationDuration, ';text-transform:"uppercase";text-decoration:none;letter-spacing:.02rem}').concat(element, ".__jsx-style-dynamic-selector:hover,").concat(element, ".__jsx-style-dynamic-selector:active,").concat(element, ".__jsx-style-dynamic-selector:active:focus{background:").concat(btnBackgrounds.hover.background, ";border:").concat(btnBorders.hover.border, ";color:").concat(btnColors.hover.color, ";text-underline-position:under}").concat(element, ".__jsx-style-dynamic-selector:focus-visible{-webkit-box-shadow:0px 0px 0px ").concat(focusOutline.size, " ").concat(focusOutline.colors.default, ";-moz-box-shadow:0px 0px 0px ").concat(focusOutline.size, " ").concat(focusOutline.colors.default, ";box-shadow:0px 0px 0px ").concat(focusOutline.size, " ").concat(focusOutline.colors.default, "}").concat(element).concat(disabled, ".__jsx-style-dynamic-selector,").concat(element).concat(disabled, ".__jsx-style-dynamic-selector button.__jsx-style-dynamic-selector:hover,").concat(element).concat(disabled, ".__jsx-style-dynamic-selector button.__jsx-style-dynamic-selector:focus,").concat(element).concat(disabled, ".__jsx-style-dynamic-selector button.__jsx-style-dynamic-selector:active,").concat(element).concat(disabled, ".__jsx-style-dynamic-selector button.__jsx-style-dynamic-selector:active:focus{opacity:").concat(mutedOpacity, ";cursor:default;color:").concat(btnColors.color, ";text-decoration:none;background:").concat(btnBackgrounds.background, ";border:").concat(btnBorders.border, ";-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;pointer-events:none}")),
        className: _style.default.dynamic([
            [
                "7bd8f376514b45ba",
                [
                    element,
                    variant === "toggle" ? 500 : 700,
                    spacers.s2,
                    btnRadius[shape],
                    round ? "auto" : "nowrap",
                    !round ? "auto" : ({
                        sm: "24px",
                        md: "32px",
                        lg: "40px"
                    })[size],
                    !round ? "auto" : ({
                        sm: "24px",
                        md: "32px",
                        lg: "40px"
                    })[size],
                    btnBackgrounds.background,
                    btnBorders.border,
                    btnColors.color,
                    round ? "12px" : ({
                        sm: "12px",
                        md: "12px",
                        lg: "14px"
                    })[size],
                    round ? "12px" : ({
                        sm: "16px",
                        md: "16px",
                        lg: "24px"
                    })[size],
                    round ? "0" : paddingVariants[size],
                    animationDuration,
                    element,
                    element,
                    element,
                    btnBackgrounds.hover.background,
                    btnBorders.hover.border,
                    btnColors.hover.color,
                    element,
                    focusOutline.size,
                    focusOutline.colors.default,
                    element,
                    disabled,
                    element,
                    disabled,
                    element,
                    disabled,
                    element,
                    disabled,
                    element,
                    disabled,
                    mutedOpacity,
                    btnColors.color,
                    btnBackgrounds.background,
                    btnBorders.border
                ]
            ]
        ])
    };
};

//# sourceMappingURL=renderAdminButtonStyles.js.map